import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@material-ui/core'
import { css } from 'emotion'
import { observer, useLocalStore } from 'mobx-react-lite'
import React from 'react'
import { Redirect } from 'react-router'
import {
  EAccountStatus,
  getAccountStatus,
  IAccount,
  paths,
} from 'shopify-payment-core'

import { AccountStatusDisplay } from '../atoms/AccountStatus'
import { CopyToClipboard } from '../atoms/CopyToClipboard'
import { useRoot } from '../atoms/RootProvider'
import { useFirebaseQuery } from '../hooks/useFirebaseQuery'

const statuses: EAccountStatus[] = Object.keys(EAccountStatus)
  .filter(s => isNaN(parseInt(s, 10)))
  .map(s => EAccountStatus[s])

const defaultActiveStates = [
  EAccountStatus.ACTIVE,
  EAccountStatus.TRIAL,
  EAccountStatus.DUEDATE,
  EAccountStatus.EXPIRED,
  EAccountStatus.NOINVOICE,
  EAccountStatus.NOPLAN,
]

const copyToClipboard = css`
  cursor: pointer;
  color: coral;
`

export const EmailExportRoute = observer(() => {
  const { auth } = useRoot()

  const { data, loading } = useFirebaseQuery<Dictionary<IAccount>>(
    paths.gopay.accounts,
    { subscribe: false },
  )

  const state = useLocalStore(() => ({
    active: new Set(defaultActiveStates),
  }))

  const preRef = React.useRef<HTMLPreElement | null>(null)

  const renderList = () => {
    const active = new Set(
      Object.values(data!)
        .filter(account => {
          const status = getAccountStatus(account)
          return state.active.has(status)
        })
        .map(account => account.contactEmail),
    )

    const output = Array.from(active.values()).join('; ')

    return (
      <div
        style={{ fontSize: '1.2rem', whiteSpace: 'normal', padding: '1rem' }}
      >
        <CopyToClipboard text={output} className={copyToClipboard}>
          Zkopírovat do schránky
        </CopyToClipboard>
        <pre ref={preRef} style={{ whiteSpace: 'normal' }}>
          {output}
        </pre>
      </div>
    )
  }

  React.useEffect(() => {
    if (preRef.current) {
      preRef.current.focus()
    }
  })

  if (!auth.isAdmin) {
    return <Redirect to="/" />
  }

  return (
    <>
      <FormControl component="fieldset" style={{ margin: '1rem' }}>
        <FormLabel component="legend">Filtrovat stavy</FormLabel>
        <FormGroup>
          {statuses.map(status => (
            <FormControlLabel
              key={status}
              control={
                <Checkbox
                  checked={state.active.has(status)}
                  onChange={() => {
                    if (state.active.has(status)) {
                      state.active.delete(status)
                    } else {
                      state.active.add(status)
                    }
                  }}
                  value={status}
                />
              }
              label={<AccountStatusDisplay status={status} />}
            />
          ))}
        </FormGroup>
      </FormControl>
      <hr />
      {loading ? <h2>...</h2> : renderList()}
    </>
  )
})
